import { useDispatch } from 'react-redux'
import { AppThunk } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`

export const useThunkDispatch = () => useDispatch<AppThunk>()